export default __webpack_public_path__ + "static/media/PrimaryArrow.d7026982.svg";